import axios from 'axios'

const jacktearleapi = axios.create({
  baseURL: process.env.VUE_APP_API
})

export function GetPosts () {
  return jacktearleapi.get(`blog`)
}

export function GetPostImage (postid, imageName) {
  return process.env.VUE_APP_API +
    'blog/file/' +
    postid +
    '/' +
    imageName
}

export function GetPost (postid) {
  return jacktearleapi.get(`blog/` + postid)
}

export function GetRandomJoke (exludeId) {
  var url = `joke/random`

  if (typeof (exludeId) !== 'undefined') { url += `/` + exludeId }

  return jacktearleapi.get(url)
}
